import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 85vh;

  .members-body {
    overflow-y: auto;
  }

  .members-footer {
    flex-shrink: 0;
  }

  .members-input-box {
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 4px;
  }

  input.form-control {
    border: 0;
    box-shadow: none;
    background: transparent;
  }

  .members-team-row {
    width: 100%;
    border: 0;
    background: transparent;
    border-radius: 6px;
    padding: 4px 6px;
  }

  .members-team-row:hover {
    background: ${(props) => props.theme.$gray200};
  }
`;
